<app-page-header title="Descubre otros seguros onLygal" subtitle="Amplía tu protección legal con onLygal" [accent]="true"></app-page-header>

<div class="container">
    <div class="hire-container">
        <div *ngIf="undefined === response" class="pre-loading">
            <p>Cargando<span>.</span><span>.</span><span>.</span></p>
        </div>

        <div class="hire-content wow fadeInUp" data-wow-duration="1s" [hidden]="undefined === response">

            <div class="hire-notice">
                <img class="hire-notice__icon" src="resources/assets/images/main-page/ic-info.svg" alt="" aria-hidden="true">
                <p class="hire-notice__text">
                    Para contratar otro seguro de onLygal contacta con tu <a class="hire-notice__link" [routerLink]="['/profile']" [queryParams]="{section: 'help'}">mediador de seguro</a>
                </p>
                <!--
                <img class="hire-notice__close" src="resources/assets/images/main-page/ic-close.svg" alt="" aria-hidden="true">
                -->
            </div>

            <div class="hire-list">
                <app-product-hire-service *ngFor="let item of newProducts" [data]="item"></app-product-hire-service>
            </div>

            <!--
            <div class="hire-disclaimer">
                <p>Precios orientativos. El precio final depende de las coberturas seleccionadas y perfil de riesgo.</p>
            </div>
            -->
        </div>
    </div>
</div>

<app-footer></app-footer>
